<template>
    <div class="page-404">
        <img class="page-404__svg" src="./images/404.svg" alt="404 robot"/>
        <z-caption tag="h2" class="page-404__title" v-html="text.title"></z-caption>
        <p class="text-size-xl" v-html="text.description"></p>
        <vue-raw :raw="text.descriptionAdd" />
    </div>
</template>

<script>
import { localize } from '@/utils/i18n'

export default {
    name: 'page-404',
    data () {
        return {
            text: {
                title: localize({
                    ru: 'К сожалению, эта страница не&nbsp;найдена',
                    en: 'Unfortunately, this page was not found'
                }),
                description: localize({
                    ru: 'Возможно, вы ввели неправильный адрес или страница была удалена.',
                    en: 'You may have entered the wrong address or the page may have been deleted.'
                }),
                descriptionAdd: localize({
                    ru: '<p class="text-size-xl">Вернитесь на&nbsp;<z-link href="/ru/">главную страницу</z-link>.</p>',
                    en: '<p class="text-size-xl">Go back to the <z-link href="/en/">home page</z-link>.</p>'
                })
            }
        }
    }
}
</script>

<style lang="scss">
.page-404 {
    width: 100%;
    margin-top: 100px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;

    @include breakpoint (mobile) {
        margin-top: 50px;
    }

    &__svg {
        margin-bottom: $token-spacers-m;
    }

    &__title {
        font-size: 22px;
        font-weight: 500;
        margin-bottom: $token-spacers-s;
    }
}
</style>
